<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
      <el-divider content-position="left">商户信息</el-divider>
      <el-form-item label="商户名称" prop="title">
        <el-input v-model="info.title" placeholder="请输入商户名称"></el-input>
      </el-form-item>
      <el-form-item label="店铺名称" prop="shop_name">
        <el-input v-model="info.shop_name" placeholder="请输入店铺名称"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contact_name">
        <el-input v-model="info.contact_name" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系人手机" prop="contact_mobile">
        <el-input v-model="info.contact_mobile" placeholder="请输入联系人手机"></el-input>
      </el-form-item>
      <el-form-item label="版本" prop="version">
        <el-select v-model="info.version" placeholder="请选择">
          <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用年限" prop="year" v-if="info.id == 0">
        <el-select v-model="info.year" placeholder="请选择">
          <el-option key="0" label="请选择" value="0"></el-option>
          <el-option
              v-for="item in yearList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="pd-tp-10"></div>
      <el-divider content-position="left">账号信息</el-divider>
      <el-form-item label="登录名" prop="username">
        <el-input v-model="info.username" placeholder="请输入登录名"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="nickname">
        <el-input v-model="info.nickname" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input show-password v-model="info.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input show-password v-model="info.password2" placeholder="请输入确认密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button type="button" @click="reBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

import configure from "@/config/configure";

export default {
  data() {
    return {
      yearList: [],
      roleList: [],
      info: {
        id: 0,
        year: '',
        version: '',
        username: '',
        nickname: '',
        shop_name: '',
        contact_name: '',
        contact_mobile: ''
      },
      source_domain: this.config.SOURCE_DOMAIN,
      rules: {
        title: [
          { required: true, message: '请输入商户名称', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入登录名', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        year: [
          { required: true, message: '请选择年限', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请选择版本', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.yearList = this.$configure.yearList;
    this.getGroupList()
    if(this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
    //
  },
  computed: {
  },
  methods: {
    getGroupList() {
      var that = this
      this.$api.merchant.versionIndex({page_size: 100},function (res) {
        if(res.errcode == 0) {
          that.roleList = res.data.data
        }
      })
    },
    getInfo() {
      var that = this
      this.$api.merchant.merchantDetail({id: that.info.id}, function (res) {
        if(res.errcode == 0) {
          that.info = res.data
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    submitForm(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = {
            id: that.info.id,
            title: that.info.title,
            username: that.info.username,
            nickname: that.info.nickname,
            shop_name: that.info.shop_name,
            contact_name: that.info.contact_name,
            contact_mobile: that.info.contact_mobile,
            year: that.info.year,
            version: that.info.version,
            password: that.info.password
          }
          if(that.info.password) {
            if(that.info.password.length<7) {
              that.fail('密码长度不能小于6位，请重新填写')
              return false
            } else if(that.info.password2 != that.info.password) {
              that.fail('密码输入不一致，请重新填写')
              return false
            }
          } else if(this.info.id == 0) {
            that.fail('密码不能为空，请填写密码')
            return false
          }
          if(this.info.id == 0) {
            this.$api.merchant.merchantAdd(param,function (res) {
              if(res.errcode == 0) {
                that.success(res.errmsg)
                that.reBack()
              } else {
                that.fail(res.errmsg)
              }
            })
          } else {
            this.$api.merchant.merchantEdit(param,function (res) {
              if(res.errcode == 0) {
                that.success(res.errmsg)
                that.reBack()
              } else {
                that.fail(res.errmsg)
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style scoped>
  .box {
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    min-height: 500px;
  }
  .ruleForm {
    width: 600px;
  }
</style>
